export interface IAttachment {
    id: number;
    fileId?: number;
    type: string;
    name: string;
}

export enum AttachmentType {
    DELEGATION = 1,
    SOLUTION = 2,
    BUG_REPORT = 3,
    PEOJECT = 4
}

export interface ServerAttachment {
    id: number;
    name: string;
    type: string;
}

export interface IAttachmentUpload extends IAttachment {
    workId?: number;
    file: File;
    processed?: boolean;
    uploadProgress?: number;
    status?: 'uploading' | 'completed' | 'error';
    uploadController?: AbortController;
}

export interface UseFileUploadOptions {
    getUploadUrl: (
        fileName: string,
        fileType: string,
        workId?: number
    ) => Promise<{ url: string; fileId: number }>;
    scanFile: (fileId: number) => Promise<{ isSafe: boolean }>;
    onComplete?: (fileIds: number[]) => void;
}

export interface UseFileUploadReturn {
    attachedFiles: IAttachmentUpload[];
    uploadFiles: (files: File[]) => Promise<number[]>;
    removeFile: (fileId: number) => void;
    cancelUpload: (fileId: number) => void;
    clearFiles: () => void;
    isUploading: boolean;
}

export interface FileUploadUrlRequest {
    fileName: string;
    fileType: string;
    workId?: number;
    isBug?: boolean;
}

export interface FileRequest {
    fileId: number;
}
